var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuicebars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53857 12H15.4617L14.7693 19.6923H9.23088L8.53857 12Z",
    stroke: "#240b3b",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8462 9.69214H8.15385C7.51659 9.69214 7 10.2087 7 10.846C7 11.4832 7.51659 11.9998 8.15385 11.9998H15.8462C16.4834 11.9998 17 11.4832 17 10.846C17 10.2087 16.4834 9.69214 15.8462 9.69214Z",
    stroke: "#240b3b",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.84619C9.87573 5.84619 8.15381 7.56811 8.15381 9.69235H15.8461C15.8461 7.56811 14.1242 5.84619 12 5.84619Z",
    stroke: "#240b3b",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5383 4.30762L12.769 5.84608",
    stroke: "#240b3b",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuicebars);
export default __webpack_public_path__ + "static/media/juicebars.b118e68966304a890e60b26290a7758c.svg";
export { ForwardRef as ReactComponent };